import $ from "jquery";
import anime from "animejs";
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

export function menuLinesAnimation() {

    var isOpen = false;

    var isMouseout = true;

    var isLinesFinished = true;

    var isOpenCloseFinished = true;

    var tl = null;

    function createMenuLinesAnimation(direction) {

        if (typeof direction == 'undefined') direction = 'normal';

        var linestl = anime.timeline({
            easing: 'easeInOutCubic',
            duration: 350,
            autoplay: false,
            direction: direction,
            begin: function (anim) {
                isLinesFinished = false;
            },
            complete: function (anim) {
                isLinesFinished = true;
                linestl.reverse();                
            }
        });

        linestl.add({
            targets: '#header-menu .line--1',
            translateY: [0, '-20%'],
            duration: 350
        }, 0);

        linestl.add({
            targets: '#header-menu .line--2',
            scaleX: [1, 0.8],
            translateY: [0, '-10%'],
            duration: 350
        }, 0);

        linestl.add({
            targets: '#header-menu .line--3',
            scaleX: [1, 0.6],
            duration: 350
        }, 0);

        return linestl;
    };

    function createMenuOpenCloseAnimation(direction) {

        if (typeof direction == 'undefined') {
            direction = 'normal';
        }
        isOpen = (direction == 'normal');
        var $menu = $('#menu');
        var $header = $('#header');

        var opentl = anime.timeline({
            easing: 'easeInOutCubic',
            duration: 750,
            autoplay: false,
            direction: direction,
            begin: function (anim) {
                isOpenCloseFinished = false;
                $menu.find('.menu-wrapper').css('overflow','hidden');
                if (isOpen) {
                    $menu.show();
                    disableBodyScroll(null, {reserveScrollBarGap: true});
                    if ($header.hasClass('header--scrolled')) {
                        $header.addClass('header--scrolled-pause');
                        $header.removeClass('header--scrolled');
                    }
                }
            },
            complete: function (anim) {
                isOpenCloseFinished = true;
                opentl.reverse();
                $menu.find('.menu-wrapper').css('overflow','');
                if (!isOpen) {
                    $menu.hide();
                    enableBodyScroll(null, {reserveScrollBarGap: true});
                    var endtl = createMenuLinesAnimation('reverse');
                    endtl.play();
                    isMouseout = true;
                    if ($header.hasClass('header--scrolled-pause')) {
                        $header.addClass('header--scrolled');
                        $header.removeClass('header--scrolled-pause');
                    }
                }
            }
        });

        opentl.add({
            targets: '#header-menu .line--1',
            translateY: ['-20%', '-25%'],
            translateX: [0, '-19%'],
            rotate: [0, '-45deg'],
            duration: 350
        }, 0);

        opentl.add({
            targets: '#header-menu .line--2',
            scaleX: [0.8, 0],
            translateY: ['-10%', '-6.8991%'],
            duration: 350
        }, 0);

        opentl.add({
            targets: '#header-menu .line--3',
            scaleX: [0.6, 1],
            rotate: [0, '45deg'],
            translateY: [0, '-21%'],
            translateX: [0, '28%'],
            duration: 350
        }, 0);

        opentl.add({
            targets: '#header-menu #logo-menu',
            translateX: [0, '-8%'],
            duration: 350
        }, 0);

        opentl.add({
            targets: '#menu',
            translateX: ['100%', 0],
            duration: 350
        }, 0);

        if (direction == 'normal') {

            opentl.add({
                targets: '#menu .menu-bg',
                opacity: [0, 1],
                duration: 850
            }, 0);
            opentl.add({
                targets: '#menu .menu-list-el, #menu .menu-sublist-el, #menu .submenu-list',
                opacity: [0, 1],
                translateY: ['100%', 0],
                delay: anime.stagger(100)
            }, 250);

        }

        return opentl;
    };

    function createMenuRotationAnimation() {

        var opentl = anime.timeline({
            easing: 'easeInOutCubic',
            duration: 350,
            autoplay: true,
            complete: function(anim) {
                $('#header-menu #logo-menu').css({
                    'transform-origin': '',
                    'transform': 'translateX(-8%)'
                });
            }
        });

        opentl.add({
            targets: '#header-menu #logo-menu',
            transformOrigin: '58.3333% 58.3333%',
            duration: 0
        }, 0);

        opentl.add({
            targets: '#header-menu #logo-menu',
            rotate: [0, '180deg'],
            duration: 350
        }, 0);
    }

    function removeAnimations() {
        anime.remove('#menu, #header-menu .line--1, #header-menu .line--2, #header-menu .line--3');
    }

    return {
        expand: function() {
            removeAnimations();
            tl = createMenuLinesAnimation();
            tl.play();
            isMouseout = false;
        },
        contract: function() {
            if (!isMouseout && isLinesFinished) {
                removeAnimations();
                tl = createMenuLinesAnimation('reverse');
                tl.play();
            } else {
                tl.reverse();
            }
            isMouseout = true;
        },
        toggleOpenClose: function() {
            if (!isOpen) {
                if (isOpenCloseFinished) {
                    removeAnimations();
                    tl = createMenuOpenCloseAnimation();
                    tl.play();
                } else {
                    tl.reverse();
                    isOpen = true;
                }
            } else {
                if (isOpenCloseFinished) {
                    removeAnimations();
                    tl = createMenuOpenCloseAnimation('reverse');
                    tl.play();
                } else {
                    tl.reverse();
                    isOpen = false;
                }
            }
        },
        rotate: function() {
            removeAnimations();
            tl = createMenuRotationAnimation();
        }
    }
};
